import React, { useState, useCallback, useEffect,PointerEvent, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import clsx from 'clsx';

import BackgroundImage from './BackgroundImage';
import { Twig, TwigButton } from '../types';
import Paper from './Paper';
import { calculateDiscount } from '../lib/utils';
import Text from './Text';
import LinkButton from './LinkButton';
import Button from './Button';
import Rating from '../pages/TwigDetails/DetailsCard/Rating';
import IconButton from './IconButton';
import { FaHeart, FaShare, FaUserPlus, FaUserCheck, FaCommentDots, FaEye } from 'react-icons/fa';
import { deleteTodoByTwigID, addTwigToTodo } from '../services/TwigService';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../config/store';
import { removeUserFollow, addUserFollow } from '../actions/auth';
import { followUser, unfollowUser } from '../services/ProfileService';
import { showLoginModal } from '../actions/ui';
import AddToCartModal from './AddToCartModal';
import { reaction } from '../services/productService';
import { track } from '../services/mixpanelService';
import Loader from './Loader';
import { dataService } from '../services/sharedDataService';

export interface TwigCardProps {
  twig: Twig;
  height?: string;
}

const TwigCard: React.FC<TwigCardProps> = ({ twig, height = "318px" }) => {
  const classes = useStyles({ "height": height });
  const hasDiscount = twig.product && twig.product.originalPrice !== twig.product.discountedPrice && twig.product.discountedPrice != 0;
  const discount = hasDiscount
    ? calculateDiscount(twig.product.originalPrice, twig.product.discountedPrice)
    : 0;
  const isAuthenticated = useSelector<RootState, boolean>(
    (state) => state.auth.isAuthenticated,
  );
  const followerList = useSelector<RootState, number[]>(
    (state) => state.auth.usersFollow,
  );
  const currencyCode = twig.product.currency.currencyCode;

  const [isFavourite, setIsFavourite] = useState(twig.isFavourite);
  const [isFavouriting, setIsFavoriting] = useState(false);
  const [isFollower, setIsFollower] = useState(false);
  const [buyModalOpen, setBuyModalOpen] = useState(false);
  const [button, setButton] = useState<TwigButton | null>(null);

  //for play video
  const [loading, setLoading] = useState<boolean>(false);
  const [play, setPlay] = useState<boolean>(false);




  const dispatch = useDispatch();

  const handleToggleBuyModal = useCallback(() => {
    (async () => {

      setBuyModalOpen(!buyModalOpen);
      if (!buyModalOpen) {
        var x = await reaction({ "type": "Click", "product_id": twig.product.id, "twig_id": twig.id })
        track("buy_now")
        track("add_to_cart")
        track("begin_checkout")
      }
    })()
  }, [buyModalOpen]);

  const videoRef = useRef<HTMLVideoElement>();


  const handleVideoMouseOver = useCallback((isEnter: boolean) => {
    if (!videoRef.current) return;
    const video = videoRef.current;
    const isVideoPlaying = !!(
      video.currentTime > 0 &&
      !video.paused &&
      !video.ended &&
      video.readyState > 2
    );
    if (!isEnter) {
      setLoading(false);
      setPlay(false)
      video.pause();
    } else {
      setPlay(true)
      setLoading(true);
      video.currentTime = 0;
      video.play();
    }
  }, [videoRef]);

  useEffect(() => {
    window.addEventListener('scroll', (event) => {
      let element = videoRef.current;
      if (window.innerWidth < 760) {
        if (element) {

          const isVideoPlaying = !!(
            element.currentTime > 0 &&
            !element.paused &&
            !element.ended &&
            element.readyState > element.HAVE_CURRENT_DATA
          );

          var rect = element.getBoundingClientRect();
          var isInViewport =
            rect.top >= 0 && rect.top <= 20 &&
            // rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)  /* or $(window).width() */


          if (isInViewport && element.scrollHeight - element.scrollTop === element.clientHeight) {
            if (!isVideoPlaying) {
              // alert(isInViewport)
              console.log(element.id)
              element.muted = false
              element.play();
            }
          }
          else if (element) {
            element.muted = true
            element.pause();
          }
        }
      }
    });
    twig.buttons.forEach(element => {
      if (element.status == "Active") {
        setButton(element);
      }
    });
    if (followerList.indexOf(+twig.user.id) != -1) {
      setIsFollower(true);
    }
    else {
      setIsFollower(false);

    }
  }, [followerList, twig])


  const goToLink = useCallback((link, isTwig = true) => {
    (async () => {
      try {
        window.open(link, "_blank") //to open new page    
        if (isTwig) {
          var x = await reaction({ "type": "Click", "product_id": twig.product.id, "twig_id": twig.id })
          track("buy_now")
          track("add_to_cart")
          track("begin_checkout")
        }
      } catch (error) {

      }
    })();

  }, []);




  const handleAddToFavourites = useCallback(() => {
    (async () => {
      setIsFavoriting(true);
      try {
        if (isFavourite) {
          twig.favorites--
          setIsFavourite(false);
          await deleteTodoByTwigID(twig.id);
        } else {
          twig.favorites++
          setIsFavourite(true);
          await addTwigToTodo(twig.id);
          track("favorite")
        }
      } catch (e) {
        if (isFavourite) {
          twig.favorites--
          setIsFavourite(false);
        } else {
          setIsFavourite(true);
          twig.favorites++
        }
      }
      setIsFavoriting(false);
    })();
  }, [isFavourite, twig]);

  const handleUserFollow = useCallback(() => {
    (async () => {
      try {
        if (!isAuthenticated) {
          dispatch(showLoginModal());
          return
        }
        if (isFollower) {
          await unfollowUser(+twig.user.id);
          dispatch(removeUserFollow(+twig.user.id));
          track("un_follow")

        } else {
          await followUser(+twig.user.id);
          dispatch(addUserFollow(+twig.user.id));
          track("follow")
        }
      } catch (e) { }
    })();
  }, [isFollower, twig, isAuthenticated]);
  const handleShare = useCallback(() => {
    try {
      // @ts-ignore
      if (typeof window.navigator.share === 'function') {
        // @ts-ignore
        window.navigator.share({
          text: twig.description,
          url: window.location.href + twig.uniqueName,
        });
        track("share")
      }
    } catch (e) { }
  }, [twig]);

  const handleCanPlay = useCallback(() => {
    if (!videoRef.current) return;
    setLoading(false)
    const video = videoRef.current;
    if (play) {
      video.play()
    }
  }, [videoRef, play]);

  return (
    <>

      <AddToCartModal
        twig={twig}
        product={twig.product}
        show={buyModalOpen}
        onHide={handleToggleBuyModal}
        onClose={handleToggleBuyModal}
        centered
      />
          

      <Paper className={classes.paper}>
        <div className={classes.header}>
          <Link to={`/${twig.uniqueName}`}>
            {twig.mediaType === 'IMAGE' || twig.mediaType === 'UNKNOWN' ? (
              <div className={classes.imageBox}>
                <BackgroundImage
                  src={twig.mediaUrl}
                  height={height}
                  width="100%"
                  className={classes.imageBoxBackground}
                  resizeMode="cover"
                />
              </div>
            ) : (
              <>
                <Loader className={classes.loader} loading={loading} size={30} />
                <div className={classes.videoBox}>
                  <video id={twig.id} className={classes.video}
                    // @ts-ignore
                    ref={videoRef}
                    muted
                    loop
                    preload="none"
                    onCanPlay={() => handleCanPlay()}
                    poster={twig.mediaThumbUrl}
                    onMouseEnter={() => handleVideoMouseOver(true)}
                    onMouseLeave={() => handleVideoMouseOver(false)}
                    controls={false}
                  >
                    <source src={twig.mediaUrl} />
                  </video>
                </div>
              </>
            )}
          </Link>
          <div className={classes.userAvatarBox}>
            <div className={classes.avatarBox}>
              <Link to={twig.user.username}>
                <Image
                  className={classes.avatar}
                  src={twig.user.avatarUrl}
                  alt={twig.user.name}
                  roundedCircle
                />
              </Link>
            </div>

            <div onClick={handleUserFollow} className={clsx(classes.followIconBox, isFollower ? classes.followIconBoxFollower : null)}>
              {!isFollower ? <FaUserPlus className={classes.followIcon} /> :
                <FaUserCheck className={classes.followIcon} />}
            </div>

            <Link className={classes.linkUsername} to={twig.user.username}>
              <Text className={classes.username} as="span" color="white" bold>
                {twig.user.name}
              </Text>
            </Link>
          </div>
        </div>
        <div className={clsx(classes.body, 'p-3')}>
          <div className={classes.priceAndActions}>
            <div>
              <Text
                className={clsx(classes.priceText, classes.currentPrice)}
                as="span"
                uppercase
                bold
              >
                {hasDiscount ? twig.product.discountedPrice : twig.product.originalPrice ? twig.product.originalPrice : twig.price} {currencyCode}
              </Text>
              {hasDiscount ? (
                <div className={classes.discountBox}>
                  <Text as="span" color="white" bold>
                    {discount}%
                  </Text>
                </div>
              ) : null}
              {hasDiscount ? (
                <Text
                  className={clsx(classes.priceText, classes.oldPrice)}
                  as="span"
                  uppercase
                  decoration="line-through"
                >
                  {twig.product.originalPrice} {currencyCode}
                </Text>
              ) : null}
            </div>
            <div>
              {button != null ?
                button.type == 'CALL' || button.type == 'EXPRESS_INTEREST' ? (
                  <LinkButton
                    key={button.id}
                    className={clsx(classes.actionBtn)}
                    color="primary"
                    size="large"
                    href={button.action}
                    target="_blank"
                    rounded
                  >
                    <Text color='white' as="span" bold capitalized>
                      {button.title}
                    </Text>
                  </LinkButton>
                ) :
                  button.type == 'OPEN_URL' ?
                    <Button
                      className={clsx('mr-2', classes.actionBtn)}
                      onClick={e => goToLink(button.action)}
                      color="primary"
                      rounded
                    >
                      <Text color='white' as="span" bold capitalized>
                        {button.title}
                      </Text>
                    </Button>
                    :
                    <Button
                      className={clsx('mr-2', classes.actionBtn)}
                      onClick={handleToggleBuyModal}
                      color="primary"
                      rounded
                    >
                      <Text color='white' as="span" bold capitalized>
                        Add To Cart
                      </Text>
                    </Button>
                :
                twig.product.is_verified ?
                  twig.product.affiliate == "EXTERNAL" || twig.product.affiliate == "INTERNAL" ?
                    <Button
                      className={clsx('mr-2', classes.actionBtn)}
                      onClick={e => goToLink(twig.product.affiliate == "EXTERNAL" ? twig.product.affiliate_link : twig.product.original_url)}
                      color="primary"
                      rounded
                    >
                      <Text color='white' as="span" bold capitalized>
                        Buy on {twig.product.business.name}
                      </Text>
                    </Button>

                    :
                    <Button
                      className={clsx('mr-2', classes.actionBtn)}
                      onClick={handleToggleBuyModal}
                      color="primary"
                      rounded
                    >
                      <Text color='white' as="span" bold capitalized>
                        Add To Cart
                      </Text>
                    </Button>

                  : null
              }
            </div>
          </div>
          <div className={classes.titleBox}>
            {twig.product.photo ? (
              <div className={classes.twigAvatarBox}>
                <Image
                  className={classes.twigAvatar}
                  src={twig.product.photo}
                  alt=""
                  roundedCircle
                />
              </div>
            ) : null}
            <div>
              <Link className={classes.link} to={`/${twig.product.uniqueName}`}>
                <Text as="h1" fontSize="size1" bold>
                  {twig.product.name}
                </Text>
              </Link>

              <Link className={classes.link} to={`/${twig.business.uniqueName}`}>
                <Text as="span" subText>
                  {twig.business.name}
                </Text>
              </Link>
            </div>
          </div>
          <div className={classes.description}>
            <Text>
              {
                twig.description?.length > 100 ? <> {twig.description?.slice(0, 100)}... <div className={classes.moreDiv} onClick={e => goToLink(twig.uniqueName, false)}> < Text className={classes.more} as="span">more</Text></div> </> : twig.description
              }
              {/* {twig.description} */}
              {/* {`${twig.description?.slice(0, 125)}${twig.description?.length > 125 ? <Text as="span">sssss</Text> : ''
                }`} */}
            </Text>
          </div>
          <div>
            {twig.tags?.map((tag) => (
              <Text key={tag.id} color="default" className={classes.tag} as="span">
                #{tag.name}
              </Text>
            ))}
            {twig.product.tags?.map((tag) => (
              <Text key={tag.id} color="default" className={classes.tag} as="span">
                #{tag.name}
              </Text>
            ))}
          </div>
          <Rating
            cardInnerBoxClassName={classes.ratingCardInnerBox}
            cardClassName={classes.ratingCard}
            twig={twig}
          />

          <div className={clsx(classes.reactionsBox, 'mt-3')}>
            <div className={clsx(classes.reaction)}>
              <div className={classes.reactionInner}>
                <IconButton
                  onClick={handleAddToFavourites}
                  disabled={isFavouriting}
                  title="Favourite"
                >
                  <FaHeart
                    className={clsx(classes.reactionIcon, {
                      [classes.favourite]: isFavourite,
                    })}
                  />
                </IconButton>
                <Text className={classes.reactionText} as="span">
                  {twig.favorites}
                </Text>
              </div>
            </div>

            {/* <div className={clsx(classes.reaction)}>
                  <div className={classes.reactionInner}>
                    <FaRetweet className={classes.reactionIcon} />
                    <Text className={classes.reactionText} as="span">
                      33
                    </Text>
                  </div>
                </div> */}

            <div className={clsx(classes.reaction)}>
              <div className={classes.reactionInner}>
                <FaEye className={classes.reactionIcon} />
                <Text className={classes.reactionText} as="span">
                  {twig.views}
                </Text>
              </div>
            </div>

            <div className={clsx(classes.reaction)}>
              <div className={classes.reactionInner}>
                <IconButton title="Share"
                  onClick={handleShare}
                >
                  <FaShare className={classes.reactionIcon} />
                </IconButton>
              </div>
            </div>
            {/* <div className={clsx(classes.reaction)}>
                  <div className={classes.reactionInner}>
                    <FaEllipsisH className={classes.reactionIcon} />
                  </div>
                </div> */}
          </div>
        </div>
      </Paper>

    </>
  );
};

const useStyles = createUseStyles({
  paper: {
    position: 'relative',
    marginBottom: '15px',
  },
  loader: {
    position: 'absolute',
    left: '50%',
    top: '50%'
  },
  header: {
    position: 'relative',
    // height: "0",
    // width: "100%",
    // paddingBottom: "100%"
  },
  imageBox: {
    textAlign: 'center',
    // maxHeight: '380px',
  },
  imageBoxBackground: {
    paddingBottom: "100%"
  },
  videoBox: (props: { height: string; }) => ({
    textAlign: 'center',
    height: props.height,
    width: "100%",
    paddingBottom: "100%",
    overflow: "hidden"
  }),
  image: {},

  video: {
    width: '100%',

  },
  userAvatarBox: {
    position: 'absolute',
    top: '15px',
    right: '15px',
  },
  avatarBox: {
    width: '40px',
    height: '40px',
    marginLeft: 'auto',
  },
  avatar: {
    width: '100%',
    height: '100%',
  },
  followIconBox: {
    position: "absolute",
    top: '-5px',
    width: '22px',
    cursor: 'pointer',
    height: '22px',
    backgroundColor: '#522583',
    borderRadius: '50%',
    right: '-5px'
  },
  followIconBoxFollower: {
    backgroundColor: '#000'
  },
  // followIconBox:{

  // }
  followIcon: {
    color: 'white',
    fontSize: '15px',
    marginBottom: '7px',
    marginLeft: '4px'
  },
  linkUsername: {
    '&:hover': {
      textDecoration: "none"
    }
  },
  username: {
    textShadow: '1px 1px 3px #000',
    fontSize: '0.8rem',
    textAlign: 'center',
  },
  body: {
    position: 'relative',
    padding: '1rem 1rem 0.5rem 1rem !important'
  },
  priceAndActions: {
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  priceText: {
    display: 'inline-block',
    fontSize: '1.3rem',
    marginRight: '10px',
  },
  currentPrice: {},
  oldPrice: {
    color: '#522583 !important',
    fontSize: '1.1rem',
  },
  discountBox: {
    padding: '5px 10px',
    position: 'absolute',
    top: '-50px',
    left: '10px',
    borderRadius: '5px',
    backgroundColor: '#522583',
  },
  actionsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actionBtn: {
    flex: 1,
    fontSize: '1rem',
    backgroundColor: '#522583',
    padding: '6px 15px',
    borderRadius: '20px',
    display: 'block',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  titleBox: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-start',
    alingItems: 'center',
  },
  twigAvatarBox: {
    marginRight: '20px',
    width: '64px',
    height: '64px',
  },
  twigAvatar: {
    width: '64px',
    height: '64px',
  },
  link: {
    color: '#000000',
    '&:hover': {
      color: '#000000',
    },
  },
  description: {
    marginTop: '20px',
  },
  tag: {
    display: 'inline-block',
    marginRight: '5px',
    color: '#E9C546 !important',
  },
  ratingCard: {
    padding: '5px',
    fontSize: '0.75rem',
    minWidth: 'calc(25% - 8px)',
    '&:last-of-type': {
      marginRight: '0',
    },
  },
  ratingCardInnerBox: {
    flexDirection: 'column',
  },
  reactionsBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  reaction: {
    display: 'inline-block',
    color: '#b9b9b9',
    width: '33%',
    margin: '0px auto'
  },
  reactionInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  reactionIcon: {
    color: '#DADADA',
  },
  favourite: {
    color: 'red',
  },
  reactionText: {
    marginLeft: '5px',
  },
  moreDiv: {
    display: "inline"
  },
  more: {
    color: '#522583 !important',
    cursor: 'pointer',
    "&:hover": {
      textDecoration: "underline"
    }
  }
});

export default TwigCard;
